export default class Timeline {
  constructor($el, opts) {
    this.$el = $el;
  }

  setModifier = ($elm, visible = true) => {
    const method = visible ? 'setAttribute' : 'removeAttribute';
    $elm[method]('m-selected', '');
  };

  toggleCurrentItem = (item, current) => {
    const isCurrent = item === current;
    this.setModifier(this.items[item], isCurrent);
    this.setModifier(this.triggers[item], isCurrent);
  };

  revealCurrent = (current = 0) => {
    return Object.keys(this.items).forEach(item =>
      this.toggleCurrentItem(item, current)
    );
  };

  bindTriggerEvents = () => {
    Object.keys(this.triggers).forEach((val, i) => {
      const trigger = this.triggers[i];
      trigger.addEventListener('click', () => this.revealCurrent(val), false);

      if (i === 0) {
        this.setModifier(trigger);
        this.setModifier(this.items[i]);
      }
    });
  };

  init() {
    this.items = this.$el.querySelectorAll('.ps-timeline__item');

    // Preflight integraty check
    if (!this.items) {
      console.warn("Timeline can't initialize, no items in the collection.");
      return;
    }

    this.triggers = this.$el.querySelectorAll('.ps-timeline__label');
    this.bindTriggerEvents();
  }
}



// WEBPACK FOOTER //
// ./js/modules/Timeline.js